// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"443":"073af58c","681":"beb2ae5c"}[chunkId] + ".chunk.js";
};